import React, { useState, useEffect, useContext } from "react";
import useToastContext from "hooks/useToastContext";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import AuthContext from "context/AuthContext";
import ErrorMessage from "components/ErrorMessage";
import OImage from "components/reusable/OImage";
import { Editor } from "@tinymce/tinymce-react";
import noImageFound from "../../assets/images/No-image-found.jpg";

const EditStaticContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [content, setContent] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      title: location?.state?.title,
      description: location?.state?.description,
      metaTitle: location?.state?.metaTitle,
      metaDescription: location?.state?.metaDescription,
      keyword: location?.state?.keyword,
    },
  });
  const notification = useToastContext();
  const [photo, setPhoto] = useState(null); // Start with null for new uploads
  const storedImage = location?.state?.StaticContentImage; // Original image from server
  const [photoError] = useState("");

  const { updatePageName } = useContext(AuthContext);

  const onSubmit = async (data) => {
    try {
      if (content !== "<p><br></p>") {
        const formData = new FormData();
        formData.append("title", data?.title?.trim());
        formData.append("description", content);
        formData.append("StaticContentImage", photo);
        formData.append("metaTitle", data?.metaTitle);
        formData.append("metaDescription", data?.metaDescription);
        formData.append("keyword", data?.keyword);
        var path = apiPath.getStaticContent + "/" + location?.state?._id;
        const result = await apiPut(path, formData);
        if (result.data.success) {
          navigate("/static-page-management");
          notification.success(result?.data.message);
        } else {
          notification.error(result?.data.message);
        }
      } else {
        notification.error("Please enter description");
      }
    } catch (error) {
      console.log("error in get all users list==>>>>", error);
      notification.error(error.message);
    }
  };

  useEffect(() => {
    updatePageName(t("Edit Static Content"));

    if (location?.state?.description) {
      setContent(location.state.description);
    }
  }, []);

  const modulesData = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [{ color: ["red", "#785412"] }],
      [{ background: ["red", "#785412"] }],
    ],
  };
  const formatsData = [
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "header",
    "bold",
    "italic",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];

  const handleProcedureContentChange = (code) => {
    setContent(code);
  };

  // Handle image display
  const getImageSrc = () => {
    if (photo) {
      return typeof photo === "object" ? URL.createObjectURL(photo) : photo;
    }
    return storedImage || noImageFound;
  };

  useEffect(() => {
    return () => {
      if (photo && typeof photo === "object") {
        URL.revokeObjectURL(photo);
      }
    };
  }, [photo]);
  return (
    <>
      <div>
        <div className="bg-[#F9F9F9]">
          <div className="px-3 py-4">
            <div className="bg-white border border-[#E9EDF9] rounded-lg">
              <div className=" border-b-[#E3E3E3] grid gap-2 px-4 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1">
                <div className="col-span-3 flex flex-wrap  items-center" />
              </div>{" "}
              <div className="flex   pl-5 pt-4">
                <strong>{t("O_ADMIN_BLOG_IMAGE_SIZE_SUGGESTION")}</strong>
              </div>
              {/* File input with cancel button */}
              <div className="pl-5 pt-4 flex items-center gap-4">
                <div>
                  <label className="mb-2 block pr-1">
                    <strong>{t("UPLOAD_IMAGE")}</strong>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/png,image/jpeg,image/jpg"
                    name="photo"
                    onChange={(event) => {
                      if (event.target.files?.[0]) {
                        setPhoto(event.target.files[0]);
                      }
                    }}
                  />
                </div>
                {/* Show cancel button ONLY when a new image is selected */}
                {photo && (
                  <button
                    type="button"
                    onClick={() => {
                      setPhoto(null); // Clear the new image
                      // Reset file input
                      document.querySelector('input[name="photo"]').value = "";
                    }}
                    className="text-black bg-[#E1E1E1] font-normal px-4 py-2 text-sm outline-none focus:outline-none rounded ease-linear transition-all duration-150 hover:bg-gray-300 mt-6"
                  >
                    {t("CANCEL")}
                  </button>
                )}
              </div>
              {photoError && <ErrorMessage message={photoError} />}
              {/* Image display - will show stored image when no new upload */}
              <div className="pl-5 pt-4">
                <OImage src={getImageSrc()} fallbackUrl={noImageFound} />
              </div>


              <div className="p-5 shadow-md">
                <OInputField
                  inputLabel={
                    <>
                      {t("TITLE")}
                      <span className="text-red-500">*</span>
                    </>
                  }
                  wrapperClassName="relative z-0 mb-6 w-full group"
                  name="title"
                  type="text"
                  autoFocus
                  register={register("title", formValidation["title"])}
                  errors={errors}
                />
                <OInputField
                  wrapperClassName="relative z-0 mb-6 w-full group"
                  inputLabel={<>{t("META_TITLE")}</>}
                  type="text"
                  name="metaTitle"
                  register={register("metaTitle", formValidation["metaTitle"])}
                />
                <OInputField
                  wrapperClassName="relative z-0 mb-6 w-full group"
                  type="text"
                  name="metaDescription"
                  inputLabel={<>{t("META_DESCRIPTION")}</>}
                  register={register(
                    "metaDescription",
                    formValidation["metaDescription"]
                  )}
                />
                <OInputField
                  wrapperClassName="relative z-0 mb-6 w-full group"
                  type="text"
                  name="keyword"
                  inputLabel={<>{t("KEYWORD")}</>}
                  register={register("keyword", formValidation["keyword"])}
                />
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <Editor
                    apiKey="mkzldhxz903im4nozx302n82dfa451insn0l8g423ay9x8s0"
                    value={content}
                    onEditorChange={(newValue) => setContent(newValue)}
                    init={{
                      height: 500,
                      menubar: "file edit view insert format tools help",
                      plugins: [
                        "advlist",
                        "autolink",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "preview",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "code",
                        "fullscreen",
                        "insertdatetime",
                        "media",
                        "table",
                        "paste",
                        "help",
                        "wordcount",
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | " +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist outdent indent | removeformat | code | help",
                      content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
        <button
          className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
          type="button"
          onClick={() => navigate("/static-page-management")}
        >
          {t("O_BACK")}
        </button>

        <button
          className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
          type="submit"
          onClick={handleSubmit(onSubmit)}
        >
          {t("O_UPDATE")}
        </button>
      </div>
    </>
  );
};

export default EditStaticContent;
